
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconTextItalic = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M22.5.248h-7.637a1.25 1.25 0 000 2.5h1.086a.25.25 0 01.211.384L4.78 21.017a.5.5 0 01-.422.231H1.5a1.25 1.25 0 000 2.5h7.637a1.25 1.25 0 000-2.5H8.051a.25.25 0 01-.211-.384L19.22 2.98a.5.5 0 01.422-.232H22.5a1.25 1.25 0 000-2.5z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M.5 23.998a.5.5 0 010-1h3.729l14.348-22H15.5a.5.5 0 010-1h8a.5.5 0 010 1h-3.729l-14.348 22H8.5a.5.5 0 010 1h-8z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M.75 23.998a.75.75 0 010-1.5h4.8l11.2-21h-4a.75.75 0 010-1.5h10.5a.75.75 0 010 1.5h-4.8l-11.2 21h4a.75.75 0 010 1.5H.75z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconTextItalic.displayName = 'IconTextItalic';
export default IconTextItalic;